import { useState, useEffect, useRef } from 'react';
import { $get, $delete, $put, API_URL } from './store/api';
import axios from 'axios';

function Templates() {
  const [templates, setTemplates] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadLang, setUploadLang] = useState('HU');
  const [error, setError] = useState(null);
  const fileRef = useRef();

  const load = async () => {
    const res = await $get('templates');
    setTemplates(res?.data || []);
  };

  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith('.docx')) {
      setError('Only .docx files are allowed');
      fileRef.current.value = '';
      return;
    }
    setError(null);
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('template', file);
      formData.append('language', uploadLang);
      const token = localStorage.getItem('token') || '';
      await axios.post(`${API_URL}/templates`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await load();
    } catch (err) {
      setError(err.response?.data?.error || 'Upload failed');
    } finally {
      setUploading(false);
      fileRef.current.value = '';
    }
  };

  const handleLanguageChange = async (name, language) => {
    await $put(`templates/${name}`, { language });
    setTemplates(prev =>
      prev.map(t => t.name === name ? { ...t, language } : t)
    );
  };

  const handleDelete = async (name) => {
    if (!window.confirm(`Delete template "${name}"?`)) return;
    await $delete(`templates/${name}`);
    await load();
  };

  return (
    <div className="p-4">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="mb-0">Sablonok</h4>
        <div className="d-flex align-items-center gap-2">
          <select
            className="form-select form-select-sm"
            style={{ width: 80 }}
            value={uploadLang}
            onChange={e => setUploadLang(e.target.value)}
            disabled={uploading}
          >
            <option value="HU">HU</option>
            <option value="EN">EN</option>
          </select>
          <label className={`btn btn-primary btn-sm${uploading ? ' disabled' : ''}`} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
            {uploading ? 'Feltöltés...' : '+ Sablon feltöltése'}
            <input
              ref={fileRef}
              type="file"
              accept=".docx"
              style={{ display: 'none' }}
              onChange={handleUpload}
              disabled={uploading}
            />
          </label>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>Fájlnév</th>
            <th style={{ width: 120 }}>Nyelv</th>
            <th style={{ width: 100 }}>Műveletek</th>
          </tr>
        </thead>
        <tbody>
          {templates.length === 0 && (
            <tr><td colSpan={3} className="text-center text-muted">Nincs sablon</td></tr>
          )}
          {templates.map(t => (
            <tr key={t.name}>
              <td>{t.filename}</td>
              <td>
                <select
                  className="form-select form-select-sm"
                  value={t.language || ''}
                  onChange={e => handleLanguageChange(t.name, e.target.value)}
                >
                  <option value="">—</option>
                  <option value="HU">HU</option>
                  <option value="EN">EN</option>
                </select>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(t.name)}
                >
                  Törlés
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Templates;
